import { render, staticRenderFns } from "./BrandPitch.vue?vue&type=template&id=81b67b40&scoped=true"
import script from "./BrandPitch.vue?vue&type=script&lang=js"
export * from "./BrandPitch.vue?vue&type=script&lang=js"
import style0 from "./BrandPitch.vue?vue&type=style&index=0&id=81b67b40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b67b40",
  null
  
)

export default component.exports